import { render, staticRenderFns } from "./vendasProdutos.vue?vue&type=template&id=1cb104e2"
import script from "./vendasProdutos.vue?vue&type=script&lang=js"
export * from "./vendasProdutos.vue?vue&type=script&lang=js"
import style0 from "./vendasProdutos.vue?vue&type=style&index=0&id=1cb104e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports